<template>
  <a-spin class="main-layout px" size="large" :spinning="inLoader && loading">
    <div class="header px" v-if="!inLoader">
      <div class="header-content">
        <a href="https://www.angrymiao.com/" target="_blank">
          <img class="logo" :src="images.logo" alt="logo" />
        </a>
        <div class="menu">
          <a-tooltip overlayClassName="menu-tooltip">
            <div slot="title">
              <div class="tooltip-item" @click="onCBClick($paths.index, 'r2')">
                {{ $t("R2") }}
              </div>
              <div class="tooltip-item" @click="onCBClick($paths.index, 'r1')">
                {{ $t("R1") }}
              </div>
            </div>
            <a
              class="menu-item"
              :class="{
                active: [$paths.index, $paths.light, $paths.keyboard].includes(
                  $route.path
                ),
              }"
            >
              CYBERBOARD
            </a>
          </a-tooltip>
          <a
            class="menu-item"
            :class="{ active: $route.path === $paths.index65GameBoy }"
            @click="$router.push($paths.index65GameBoy)"
          >
            AM RGB 65
          </a>
          <a
            class="menu-item"
            :class="{ active: $route.path === $paths.keyboard65Fluffy }"
            @click="$router.push($paths.keyboard65Fluffy)"
          >
            PetBrick 65
          </a>
          <a
            class="menu-item"
            :class="{ active: $route.path === $paths.keyboardHatsu }"
            @click="$router.push($paths.keyboardHatsu)"
          >
            HATSU
          </a>
          <a
            class="menu-item"
            :class="{ active: $route.path === $paths.keyboardAlice }"
            @click="$router.push($paths.keyboardAlice)"
          >
            AM AFA
          </a>

          <a-popover placement="bottom" overlayClassName="account-popover">
            <template slot="content">
              <div
                class="account-item"
                style="text-align: center;"
                @click="$router.push($paths.keyboard65Less)"
              >
                {{ $t("keyboard.65Less") }}
              </div>
              <div
                class="account-item"
                @click="$router.push($paths.keyboard65LessSplit)"
              >
                {{ $t("keyboard.65LessSplit") }}
              </div>
            </template>
            <a
              class="menu-item"
              :class="{
                active: [
                  $paths.keyboard65Less,
                  $paths.keyboard65LessSplit,
                ].includes($route.path),
              }"
              @click="$router.push($paths.keyboard65Less)"
            >
              {{ isCN ? "65 LESS" : "AM Compact Touch (65 Less)" }}
            </a>
          </a-popover>
          <a
            class="menu-item"
            :class="{ active: $route.path === $paths.keyboard80 }"
            @click="$router.push($paths.keyboard80)"
          >
            AM Relic 80
          </a>
          <a
            class="menu-item"
            :class="{ active: $route.path === $paths.keyboard75 }"
            @click="$router.push($paths.keyboard75)"
          >
            BLACK DIAMOND 75
          </a>
        </div>

        <a-popover placement="bottom" overlayClassName="account-popover">
          <template slot="content">
            <div v-if="!isSignIn" class="account-item" @click="onSignInClick">
              {{ $t("auth.signIn") }}
            </div>
            <div v-if="isSignIn" class="account-item" @click="onProfileClick">
              {{ $t("auth.profile") }}
            </div>
            <div v-if="isSignIn" class="account-item" @click="onSignOutClick">
              {{ $t("auth.signOut") }}
            </div>
          </template>
          <div class="account">
            <div
              :style="{
                backgroundImage: `url(${avatar || images.avatar})`,
              }"
              class="avatar"
            ></div>
            {{ isSignIn ? nickname : $t("auth.signIn") }}
          </div>
        </a-popover>
      </div>
    </div>
    <div class="main-content">
      <c-bar class="bar" v-if="showBar" />
      <transition name="router">
        <router-view />
      </transition>
    </div>
    <c-footer v-if="!inLoader" />
    <c-qt-web-channel />
  </a-spin>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MainLayout",
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isTest: "isTest",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      loading: "loading",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("profile", {
      version: "version",
      default: "default",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
      avatar: "avatar",
      nickname: "nickname",
      uuid: "uuid",
    }),
    showBar() {
      return (
        this.inLoader &&
        !this.$route.path.includes(this.$paths.welcome) &&
        !this.$route.path.includes(this.$paths.mouseConnect)
      );
    },
  },
  methods: {
    onCBClick(path, version) {
      this.$router.push(path);
      if (this.version !== version) {
        setTimeout(() => {
          this.$store.dispatch("profile/setVersion", version);
        });
      }
    },
    onSignInClick() {
      this.$store.dispatch("user/signIn");
    },
    onSignOutClick() {
      this.$store.dispatch("user/signOut");
    },
    onProfileClick() {
      this.$router.push({
        path: this.$paths.user.replace(":uuid", this.uuid),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-layout.px {
  min-height: inherit;

  .header {
    width: 100%;
    height: $header-height;

    .header-content {
      @include flex-center;
      width: 100%;
      height: $header-height;
      background: #2f2f2f;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 1000;
      padding: 0 calc((100vw - 1400px) / 2);

      .logo {
        height: 26px;
        margin-left: 20px;
      }

      .menu {
        width: 100px;
        flex: auto;
        @include flex-center;
        justify-content: flex-start;
        margin-left: 40px;
        overflow: hidden;

        .menu-item {
          height: $header-height;
          line-height: $header-height;
          font-size: 14px;
          color: #999999;
          margin-right: 10px;
          padding: 0 10px;

          &.active {
            color: #ffffff;
          }
        }
      }

      .account {
        flex: none;
        @include flex-center;
        font-size: 14px;
        color: #ffffff;
        margin-right: 20px;
        cursor: pointer;

        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: $primary-color no-repeat center / cover;
          margin-right: 15px;
        }
      }
    }
  }

  .main-content {
    display: flex;

    > * {
      flex: auto;
    }

    .bar {
      flex: none;
    }
  }
}
</style>

<style lang="scss">
.main-layout.px {
  .ant-spin {
    z-index: 1000;
    position: fixed;
  }

  .ant-spin-container {
    height: 100vh;
  }
}
.menu-tooltip {
  max-width: none;

  .ant-tooltip-inner {
    background-color: #333333;
    color: #ffffff;
    white-space: nowrap;
    padding: 15px 30px;
    font-size: 18px;
  }

  .ant-tooltip-arrow::before {
    background-color: #333333;
  }

  .tooltip-item {
    text-align: center;
    color: #999999;
    cursor: pointer;

    + .tooltip-item {
      margin-top: 10px;
    }

    &:hover {
      color: #ffffff;
    }
  }
}
.account-popover {
  .account-item {
    color: #ffffff;
    padding: 5px 30px;
    font-size: 18px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: $primary-color;
    }
  }
}
</style>
